/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from "react";
import { Dropdown, Avatar } from "antd";
import { NavLink, useNavigate } from "react-router-dom";

import "./sideNav.css";

import Axios from "../../api/Axios";

import { useSelector } from "react-redux";

import NineDots from "../../assets/icons/DotsNine2.svg";
import { DownOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import Up from "../../assets/icons/upoutlined_.png";
import Down from "../../assets/icons/downoutlined_.png";
import PinUnchecked from "../../assets/icons/pushpin.png";
import PinChecked from "../../assets/icons/pushpinfilled.png";
import ArrowOpen from "../../assets/icons/double-right.png";
import ArrowClose from "../../assets/icons/doubleleft.png";
import ModalTesting from "./Modals/Modaltesting";
import NotifcationIcon from "../../pages/Admin-pages/CA-admin-pages/Communications/NotifcationIcon";
import { capitalizeWords } from "../icons/ApplicationColor";
import { MAIN_LOGO_BIG } from "../../ImagesSrc";

// import CorporateFareIcon from "@mui/icons-material/CorporateFare";
const CaSideNav = ({ children, props }) => {
  const namingData = useSelector((state) => state.orgdeatil);
  // Subscribe to classification changes to trigger re-render when classification updates
  const customerClassification = useSelector((state) => state.orgdeatil?.customerClassification);
  // Call props() after subscribing to state so it gets the latest classification
  const propsFunc = props();

  const history = useNavigate();

  const [isOpen, setIsOpen] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const HandleModalClose = () => {
    setIsModalVisible(false);
  };
  //console.log(cookieValue);
  const LoadCookie = () => {
    const pinnedAccessCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("pinned="));

    if (pinnedAccessCookie) {
      const cookieValue2 = pinnedAccessCookie.split("=")[1];
      if (cookieValue2 === "True") {
        setIsOpen(true);
        //console.log(isOpen);
        setPin(true);
      } else {
        setIsOpen(false);
        //console.log(isOpen);
        setPin(false);
      }

      //console.log(cookieValue); // Do something with the cookie value
    }
  };
  useEffect(() => {
    LoadCookie();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // eslint-disable-next-line no-unused-vars
  const [animate, setAnimate] = useState(true);
  const [pin, setPin] = useState(false);
  //console.log(pin);
  const userInfo = useSelector((state) => state.user);
  const firstLetter = userInfo?.data?.first_name?.[0]?.toUpperCase();
  const toggle = () => {
    if (pin) {
      setIsOpen(true);
    } else {
      if (isOpen) {
        setAnimate(true);
      }
      setIsOpen(!isOpen);
    }
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const pinToggle = async () => {
    const normalizedValues = {
      pinned: !pin,
    };
    try {
      await Axios.post("/setpin/", normalizedValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      LoadCookie();
    } catch (err) {
      //console.log(err);
    }
  };

  useEffect(() => {
    if (pin) {
      setIsOpen(true);
    }
  }, [pin]);
  useEffect(() => {
    localStorage.setItem("isOpen", isOpen);
  }, [isOpen]);

  const currentUrl = window.location.href;
  const values = userInfo?.data?.applications;
  //console.log(userInfo, values);
  const [applications, setApplications] = useState([]);
  useEffect(() => {
    setApplications(userInfo?.data?.left_menu);
  }, [userInfo]);
  const toggleDropdown = (event, index) => {
    event.preventDefault();

    const updatedApplications = [...applications]; // Shallow copy the array

    // Create a new object based on the existing object with added property
    const updatedApplication = {
      ...updatedApplications[index],
      showDropdown: !updatedApplications[index].showDropdown,
    };

    // Replace the old object with the new object in the copied array
    updatedApplications[index] = updatedApplication;

    setApplications(updatedApplications);
  };
  const getSubClass = (appName, dropDownOpen) => {
    //console.log(appName);
    //console.log(dropDownOpen);
    switch (appName) {
      case "Admin Manager":
        return currentUrl.includes("admin-manager") && !dropDownOpen;
      case "Access Manager":
        return currentUrl.includes("access-manager") && !dropDownOpen;
      case "Trak Products":
        return currentUrl.includes("trak.trainery") && !dropDownOpen;
      case "DelegateHR":
        return (
          (currentUrl.includes("dhr.trainery") ||
            currentUrl.includes("delegatehr.trainery")) &&
          !dropDownOpen
        );
      case "TNMIS":
        return currentUrl.includes("mis.trainery") && !dropDownOpen;
      // ca admin routes
      case "Organization":
        return currentUrl.includes("organization");
      case "Employees":
        return currentUrl.includes("coreapp");
      case "TraineryLearn":
        return (
          (currentUrl.includes("trainery-learn/courses") ||
            currentUrl.includes("settings/locations") ||
            currentUrl.includes("trainery-learn/bundles") ||
            currentUrl.includes("trainery-learn/topics") ||
            currentUrl.includes("settings/work-roles") ||
            currentUrl.includes("trainery-learn/learning-path") ||
            currentUrl.includes("trainery-learn/records") ||
            currentUrl.includes("trainery-learn/learning-matrix")) &&
          !dropDownOpen
        );
      case "TCustomer":
        return currentUrl.includes("ca-admin/customers") && !dropDownOpen;
      case "DOCUSTOR":
      case "Docustor":
        return currentUrl.includes("docustor");
      default:
        return false;
    }
  };
  const generateClassName = (appName, dropDownOpen) => {
    let drop;
    if (dropDownOpen) {
      drop = dropDownOpen;
    } else {
      drop = false;
    }
    let baseClass = "collapsed";
    let extraClasses = "";

    if (getSubClass(appName, drop)) {
      extraClasses = "highlighted";
    } else {
      extraClasses = "";
    }

    let className = !isOpen
      ? `${baseClass} ${extraClasses}`
      : `${baseClass} expanded ${extraClasses}`;

    return className;
  };
  const getDropDownSubClass = (appName) => {
    //console.log(appName);
    switch (appName) {
      case "Trak Learning":
        return currentUrl.includes("track/learner-board");
      case "Trak Coaching":
        return currentUrl.includes("track/learner-board");
      case "Knowledge Center":
        return currentUrl.includes("knowledge-center");
      case "Dashboard settings":
        return currentUrl.includes("dashboard-settings");
      case "Dashboard":
        return currentUrl.includes("mis.trainery");
      case "Courses":
        return (
          currentUrl.includes("trainery-learn/courses") ||
          currentUrl.includes("trainery-learn/bundles") ||
          currentUrl.includes("trainery-learn/topics") ||
          currentUrl.includes("trainery-learn/learning-path")
        );
      case "Learning Journey":
        return (
          currentUrl.includes("trainery-learn/records") ||
          currentUrl.includes("trainery-learn/learning-matrix")
        );
      case "Settings":
        return currentUrl.includes("settings/locations");

      default:
        return false;
    }
  };
  const generateDropDownClassName = (appName) => {
    let baseClass = "dropdown-content";
    let extraClasses = "";

    if (getDropDownSubClass(appName)) {
      extraClasses = "highlighted-2";
    } else {
      extraClasses = "";
    }

    let className = `${baseClass} ${extraClasses}`;

    return className;
  };

  const items2 = [
    {
      key: "1",
      type: "group",
      label: "My Apps",
      children: values.map((value, index) => {
        if (!value) return null;

        return {
          key: `${index}-sub`,
          label: (
            <div
              onClick={() => {
                window.location.href = value.url;
              }}
            >
              {value.logo !== null ? (
                <>
                  <img
                    height={20}
                    width={100}
                    src={value.logo}
                    style={{ marginLeft: "0.7rem", marginRight: "0.7rem" }}
                  />
                </>
              ) : (
                <>TNMIS</>
              )}
            </div>
          ),
        };
      }),
    },
    {
      type: "divider",
    },
    {
      key: "2",
      type: "group",
      label: "Home Page",
      children: [
        {
          key: "2-1",
          label: (
            <div
              onClick={() => {
                history("/home");
              }}
            >
              <img height={25} width={100} src={MAIN_LOGO_BIG} />
            </div>
          ),
        },
      ],
    },
  ];
  const generateClassNameHighlight = (appName, dropDownOpen) => {
    if (appName && dropDownOpen) {
      return "gray-highlight-bg";
    } else {
      return "";
    }
  };
  const scrollWrapperRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const checkOverflow = () => {
    if (scrollWrapperRef.current) {
      const { scrollWidth, clientWidth } = scrollWrapperRef.current;
      setIsOverflowing(scrollWidth > clientWidth);
    }
  };

  const scrollLeft = () => {
    scrollWrapperRef.current.scrollBy({ left: -150, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollWrapperRef.current.scrollBy({ left: 150, behavior: "smooth" });
  };

  useEffect(() => {
    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, []);

  const handleLinkClick = (path) => {
    console.log(path);
    window.location.href = path;
  };
  console.log(namingData?.logo_url, "abc bac");
  return (
    <div>
      <div className="main-header">
        <div className="test1">
          <img
            alt=""
            src={namingData?.logo_url ? namingData.logo_url : MAIN_LOGO_BIG}
            width="138.75"
            height="35"
            className="logo-styles"
          />
        </div>
        <div className="headings-container">
          {isOverflowing && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <button
                className="scroll-button-white left"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
                onClick={scrollLeft}
              >
                <LeftOutlined />
              </button>
            </div>
          )}
          <div className="navbar-scroll-wrapper-black" ref={scrollWrapperRef}>
            <div
              className="navbar-links-black"
              style={{
                marginInline: isOverflowing ? "10px" : "0px",
                paddingInline: isOverflowing ? "10px" : "0px",
              }}
            >
              {propsFunc.map((item, index) =>
                item?.redirect ? (
                  <span
                    key={index}
                    className="link-heading"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleLinkClick(item.path)}
                  >
                    {/* {item.icon} */}
                    {capitalizeWords(item.name)}
                  </span>
                ) : (
                  <NavLink
                    to={item.path}
                    key={index}
                    className={(navigationData) =>
                      navigationData.isActive
                        ? "link-heading-active"
                        : "link-heading"
                    }
                  >
                    <div style={{ display: "flex" }}>
                      {capitalizeWords(item.name)}
                    </div>
                  </NavLink>
                )
              )}
            </div>
          </div>
          {isOverflowing && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <button
                onClick={scrollRight}
                className="scroll-button-white right"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <RightOutlined />
              </button>
            </div>
          )}
        </div>
        <div className="textsNav1">
          <NotifcationIcon />

          <Dropdown menu={{ items: items2 }} placement="bottomLeft" arrow>
            <img
              alt=""
              src={NineDots}
              width="30"
              height="30"
              className="nine-dots-hover"
            />
          </Dropdown>
          <div
            className="texts-navv2"
            onClick={showModal}
            style={{ cursor: "pointer" }}
          >
            {userInfo?.data?.profile_pic ? (
              <>
                <Avatar size={30} src={userInfo?.data?.profile_pic} />
              </>
            ) : (
              <>
                <Avatar
                  size={30}
                  style={{
                    backgroundColor: "#b3cee5",
                    color: "#0000B9",
                    fontWeight: "500",
                    fontSize: "18px",
                  }}
                >
                  {firstLetter}
                </Avatar>
              </>
            )}

            <div
              className="top-text-2-test"
              style={{
                display: "flex", // Flex container
                flexDirection: "row", // Ensure text and icon are in a row
                alignItems: "center", // Center content vertically
                maxWidth: "150px", // Set your desired max width
                whiteSpace: "nowrap", // Prevent text from wrapping
                overflow: "hidden", // Hide overflow text
                textOverflow: "ellipsis", // Add "..." when text overflows
              }}
            >
              <span
                style={{
                  overflow: "hidden", // Hide overflow text inside span
                  textOverflow: "ellipsis", // Add ellipsis
                  whiteSpace: "nowrap", // Prevent wrapping
                  display: "block", // Ensure it behaves as a block element
                  maxWidth: "100%", // Ensure it respects the parent width
                }}
              >
                {userInfo?.data?.first_name}
              </span>
              <span
                style={{
                  marginLeft: "10px", // Space between text and icon
                  display: "flex", // Flex for span (optional but consistent)
                  alignItems: "center", // Center icon inside span
                }}
              >
                <DownOutlined style={{ fontSize: "12.5px" }} />
              </span>
            </div>
          </div>
        </div>
        <ModalTesting
          visible={isModalVisible}
          handleClose={HandleModalClose}
          userInfo={userInfo.data}
        />
      </div>
      <div className="container-main">
        <div style={{ width: isOpen ? "210px" : "60px" }} className="sidebar">
          <div
            className={isOpen ? "leftmenu" : "leftmenu collapsed"}
            id="leftmenu"
          >
            <div className="top_section">
              <div className={isOpen ? "bars" : "close"}>
                {isOpen && (
                  <>
                    {!pin ? (
                      <img
                        key="check"
                        className="top-section-icon-styles"
                        src={PinUnchecked}
                        alt=""
                        onClick={pinToggle}
                      />
                    ) : (
                      <img
                        key="uncheck"
                        className="top-section-icon-styles"
                        src={PinChecked}
                        alt=""
                        onClick={pinToggle}
                      />
                    )}
                    <img
                      key="close"
                      className="top-section-icon-styles-2"
                      src={ArrowClose}
                      alt=""
                      onClick={toggle}
                    />
                  </>
                )}

                {!isOpen && (
                  <img
                    key="close"
                    className="top-section-icon-styles-2"
                    src={ArrowOpen}
                    alt=""
                    onClick={toggle}
                  />
                )}
              </div>
            </div>

            {/* Applications */}
            {applications?.map((app, index) => (
              <div
                className={generateClassNameHighlight(
                  app.drop_down,
                  app.showDropdown
                )}
              >
                {app.drop_down ? (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    href="#"
                    className={generateClassName(
                      app?.key_name,
                      app.showDropdown
                    )}
                    onClick={(event) => {
                      toggleDropdown(event, index);
                    }}
                  >
                    <img src={app.logo} width="24" height="24" alt={app.name} />
                    <span>{app.name}</span>
                    <div
                      style={{
                        marginLeft: "auto",
                        display: isOpen ? "block" : "none",
                      }}
                    >
                      {app.showDropdown ? (
                        <img src={Up} alt="" width="12.5" height="12.5" />
                      ) : (
                        <img src={Down} alt="" width="12.5" height="12.5" />
                      )}
                    </div>
                  </a>
                ) : (
                  <a
                    href={app.url}
                    className={generateClassName(app?.key_name)}
                  >
                    <img src={app.logo} width="22" height="22" alt={app.name} />
                    <span>{app.name}</span>
                  </a>
                )}

                {app.drop_down && app.showDropdown && (
                  <div>
                    {app.drop_down_data.map((dropDownItem) => (
                      <div
                        className={generateDropDownClassName(
                          dropDownItem?.key_name
                        )}
                        style={{ marginLeft: isOpen ? "10px" : "0px" }}
                      >
                        <a key={dropDownItem.name} href={dropDownItem.url}>
                          <img
                            src={dropDownItem.logo}
                            width="17"
                            height="17"
                            alt={dropDownItem.name}
                          />
                          <span style={{ display: isOpen ? "block" : "none" }}>
                            {dropDownItem.name}
                          </span>
                        </a>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <main
          style={{
            maxWidth: !isOpen ? "calc(100vw - 80px)" : "calc(100vw - 230px)",
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default CaSideNav;
